import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { compose } from 'recompose';
import { propArrayShape, propFunc } from '../../../../helpers/custom-prop-types';
import IsLoadingHoc from '../../../Layout/Loading/IsLoadingHoc';
import MyFavoriteItem from './MyFavoriteItem';
const MyFavoriteItemList = ({ items, onChangeChecked }) => {
    if (items.length === 0) {
        return (_jsx("div", Object.assign({ className: 'no-data-text' }, { children: "\u304A\u6C17\u306B\u5165\u308A\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E8B\u4F8B\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093" })));
    }
    return items.map((item) => (_jsx(MyFavoriteItem, { item: item, onChangeChecked: onChangeChecked }, item.id)));
};
MyFavoriteItemList.propTypes = {
    items: propArrayShape().isRequired,
    onChangeChecked: propFunc().isRequired,
};
const enhance = compose(IsLoadingHoc);
export default enhance(MyFavoriteItemList);
